import { Component, Input } from '@angular/core';
import { File, removeExtFromUrlFile } from '../../models/file.model';

@Component({
  selector: 'app-detail-files',
  templateUrl: './detail-files.component.html',
  styleUrls: ['./detail-files.component.css']
})
export class DetailFilesComponent {
  
  @Input() files: File[];

  removeExtFromUrlFile(url: string): string {
    return removeExtFromUrlFile(url);
  }

}
